import React from 'react'
import { compose, lifecycle, withState, withHandlers } from 'recompose'

import isMobile from './IsMobileHoc'
import SidebarContainer from '../../components/Sidebar'

const MainContainer = ({ children, setContainer, setMainContainer, fixed, point, mainHeight, isMobile, Sidebar, SidebarTitle, image, sidebarClass, sidebarNoBody = false }) => (
  <div className='Container Container_top-negative' ref={setMainContainer}>
   <SidebarContainer onMount={setContainer} isFixed={fixed}  /* isAbsolute={!!point && !isMobile}*/ isMobile={isMobile} title={SidebarTitle} className={sidebarClass} noBody={sidebarNoBody}> 
      {Sidebar}
    </SidebarContainer>

    <div className='Main' style={{ minHeight: isMobile ? null : mainHeight }}>
      {children}
    </div>
  </div>
)

export default compose(
  isMobile,
  withState('point', 'setPoint', 0),
  withState('bottom', 'setBottom', 0),
  withState('fixed', 'setFixed', null),
  withState('mainHeight', 'setMainHeight', null),
  withState('container', 'setContainer', null),
  withState('mainContainer', 'setMainContainer', null),
  withHandlers({
    calcPoint: ({ setPoint, container, setContainer, setBottom, setMainHeight, mainContainer, setFixed }) => () => {
      if (!container || !mainContainer) return
      const rect = container.getBoundingClientRect()
      const main = mainContainer.getBoundingClientRect()

      if (main.height <= rect.height) setMainHeight(rect.height)
      else setMainHeight(null)

      rect.bottom && setBottom(rect.bottom)
    }
  }),
  withHandlers({
    setContainer: ({ setContainer, container, calcPoint }) => async ref => {
      if (!container && ref) {
        await setContainer(ref)
        calcPoint()
      }
    },
    handleScroll: ({ bottom, mainContainer, point = 0, setPoint }) => () => {
      let mainBottom = mainContainer.getBoundingClientRect().bottom
      if (bottom >= mainBottom && !point) setPoint(mainBottom)
      if (point && (point < mainBottom)) setPoint(0)
    }
  }),
  lifecycle({
    componentWillReceiveProps (np) {
      if (!this.props.container && np.container) this.props.calcPoint()
    },
    componentDidMount () {
      global.addEventListener('scroll', this.props.handleScroll)
      global.addEventListener('resize', this.props.calcPoint)
      this.props.calcPoint()
    },
    componentWillUnmount () {
      global.removeEventListener('scroll', this.props.handleScroll)
      global.removeEventListener('resize', this.props.calcPoint)
      this.props.calcPoint()
    }
  })
)(MainContainer)



// WEBPACK FOOTER //
// ./src/containers/Main/index.jsx